enum CardType {
  
  Withdrawals = "withdrawals",
  TopUpLimits = "topUpLimits",
  AnnualStatement = "annualStatement",
  MyLeverage = "myLeverage",
  CloseOutMethod = "closeOutMethod",
}

export default CardType;